import React, {Component} from 'react'
import './SplahsBtn.css'

export default class SplashLoginBtn extends Component {
  render () {
    const {children} = this.props

    return (
      <button {...this.props} className="splash-login-btn">
        {children}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SplahsLoginBtn.js